import { render, staticRenderFns } from "./UploadEvidenceBtn.vue?vue&type=template&id=623d3b71&scoped=true"
import script from "./UploadEvidenceBtn.vue?vue&type=script&lang=js"
export * from "./UploadEvidenceBtn.vue?vue&type=script&lang=js"
import style0 from "./UploadEvidenceBtn.vue?vue&type=style&index=0&id=623d3b71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d3b71",
  null
  
)

export default component.exports